// extracted by mini-css-extract-plugin
export default {"container":"CropModal_container__-K4e6","title":"CropModal_title__eaVKK","footer":"CropModal_footer__gZVDA"};